export const pulseColors = {
  backgroundGray: '#00000080',
  vision05: '#0080CC',
  gBlue: '#0086E2',
  offGray: '#DDD',
  green: '#1AB900',
  green2: '#3CCB00',
  green3: '#82DE66',
  green4: '#ebf7ee',
  green5: '#92cda1',
  green6: '#1c6d37',
  lightGreen: 'rgba(26,185,0,0.3)',
  lightBlueOpacity: 'rgba(0,102,255,0.3)',
  lightBlueOpacity2: 'rgba(28, 73, 109, 0.5)',
  red: '#FF0000',
  red2: '#E20000',
  darkBlue: '#1C496D',
  darkBlue2: '#175D8D',
  darkBlue3: '#000F26',
  darkBlue4: '#1C496D80',
  darkBlue5: '#5D8AAE',
  darkBlue6: '#0047B2',
  darkBlue7: '#a3cfff',
  lightBlue: '#0066FF',
  lightBlue2: '#3685EE',
  lightBlue3: '#4499FF',
  lightBlue4: '#F8FBFF',
  lightBlue5: '#e6f2ff',
  lightBlue6: '#0066FF',
  lightBlue7: '#c5dcff',
  lightBlue8: '#CDE5FF',
  lightBlueLine: '#77CFFF',
  lightBlueGrid: '#d9e9ff',
  pVBlueLight: '#009bef',
  blueLightPoint: '#00A5FF',
  greenLightPoint: '#00CC2D',
  blueLightLine: '#95C4F3',
  white: '#FFF',
  lightSecondaryBlue: '#EBF5FF',
  blueFontLabel: '#0094FF',
  darkBlueButton: '#0056D8',
  backgorundLighBlue: '#D8EBFF',
  backgroundLightBlue2: '#E1EDFF',
  backgroundLightBlue3: '#DCEAFF',
  backgroundLightBlue4: '#EBF3FF',
  backgroundLightBlue7: '#D0E3FF',
  backgroundLightBlue8: '#F4F8FF',
  backgroundLightBlue5: '#EEF5FF',
  backgroundLightBlue6: '#D0E3FF',
  backgroundLightBlue9: '#E4EAF4',
  backgroundLightBlue10: '#C0E6FF',
  gray: '#FAFAFA',
  gray2: '#F9F9F9',
  gray3: '#E5E5E5',
  gray4: '#BBBBBB',
  gray5: '#75A3FF',
  gray6: '#F4F4F4',
  gray7: '#AAAAAA',
  gray8: '#666666',
  gray9: '#888',
  gray10: '#EEE',
  btnGray: '#1F252A',
  darkGray: '#969696',
  lightGreenText: '#408E99',
  autoFlagBlue: '#E8F6FF',
  autoFlagLightBlue: '#F2FAFE',
  autoFlagDarkBlue: '#325C80',
  backgroundLightBlue: '#ECF6FF',
  placeholderBlue: '#BAC7DB',
  inputPlaceholder: '#99BBFF',
  inputPlaceholder2: '#BBBBBB',
  gNewBlueGradient1: '#003F9E',
  gNewBlueGradient2: '#001431',
  wsConnected: '#2EB900',
  wsDisconnected: '#FF1717',
  warning: '#FEBF50',
  lightWarning: '#FFD863',
  lightWarning2: '#FFD791',
  lightWarning3: '#FFF5CE',
  lightWarning4: '#FFDFA6',
  lightGreen: '#ECFFE6',
  lightGreen2: '#DCFDD2',
  lightRed: '#FFD4D4',
  lightRed2: '#FFE5E0',
  lightRed3: '#FF8A8A',
  lightRed4: '#E71D32',
  lightRed5: '#fdecec',
  lightRed6: '#b41818',
  lightRed7: '#e19f9f',
  green: '#33CC00',
  green2: '#2EB900',
  yellow: '#FFF600',
  yellow2: '#fff8e6',
  yellow3: '#64460a',
  yellow4: '#ffeab2',
  lightYellow: '#FFF8E5',
  lightGray9: '#f5f5f5',
  lightGray10: '#e0e0e0',
  lightGray11: '#f0f0f0',
  lightGray12: '#e6e6e6',
  lightGray13: '#c0c0c0',
  lightGray15: '#f2f2f2',
  lightGray16: '#F8F8F8',
  orange: '#e8a32a',
  orangeRequired: '#FF7832',
  backgroundBlueVeryLight: '#EBF3FF',
  backgroundBlueLight: '#D0E3FF',
  circleBlueLight: '#99BBFF',
  backgroundBlueLight2: '#E4EFFF',
  errorShadowLight: 'rgba(255, 68, 68, 0.1)',
  errorShadowMedium: 'rgba(255, 68, 68, 0.15)',
  errorShadowStrong: 'rgba(255, 68, 68, 0.2)',

  // Shadow and hover colors (rgba values)
  blackShadow10: 'rgba(0, 0, 0, 0.1)',
  blackShadow15: 'rgba(0, 0, 0, 0.15)',
  blackHover02: 'rgba(0, 0, 0, 0.02)',
  grayShadow20: 'rgba(180, 180, 180, 0.2)',
  grayShadow19: 'rgba(180, 180, 180, 0.19)',
  lightGray14Hover: 'rgba(248, 248, 248, 0.8)',
  lightGray15Hover: 'rgba(242, 242, 242, 0.8)'
};
